import React from 'react';
import { Route, Switch } from 'react-router';
import View from './scenes/View';
import List from './scenes/List';

const DeliveryOrderRouter = () => {
  return (
    <Switch>
      <Route path='/dashboard/delivery-orders/new' exact component={View} />
      <Route path='/dashboard/delivery-orders/:id' exact component={View} />
      <Route path='/dashboard/delivery-orders' exact component={List} />
    </Switch>
  );
};

export default DeliveryOrderRouter;
